// extracted by mini-css-extract-plugin
export default {"webgl-body":"EarthWebGL_webgl-body__Co6HD","webgl-root":"EarthWebGL_webgl-root__BVW57","webgl-earth-dot-wrapper":"EarthWebGL_webgl-earth-dot-wrapper__qb4c6"};